import { Component, inject } from '@angular/core';
import { AngularNodeViewComponent } from 'ngx-tiptap';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle } from '@angular/material/card';
import { DatePipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MsgType } from 'matrix-js-sdk';
import { DateUtils } from '../../../../../services/util';
import { HtmlInputDirective } from '../../../../../directives/sb-client-message-input/html-input.directive';
import { ReadonlyDirective } from '../../../../../directives/readonly/readonly.directive';
import { MatButton } from '@angular/material/button';
import { SbMessageTestIds } from '../../../sb-message/sb-message.test-ids';
import { AccountService } from '../../../../../services/account/account.service';
import { SpoilerChunksPipe } from '../../../../../common/pipes/spoilerChuncks.pipe';
import { SpoilerComponent } from '../../../sb-spoiler/sb-spoiler.component';

@Component({
  selector: 'app-node-view-reply',
  standalone: true,
  imports: [
    MatCard,
    MatCardHeader,
    MatCardSubtitle,
    MatCardContent,
    DatePipe,
    NgClass,
    MatIcon,
    HtmlInputDirective,
    ReadonlyDirective,
    MatButton,
    SpoilerChunksPipe,
    SpoilerComponent
  ],
  templateUrl: './node-view-reply.component.html',
  styleUrl: './node-view-reply.component.scss'
})
/**
 * Begründung: Eine Custom AngularNodeComponent um Dateien im Editor rendern zu können
 */
export class NodeViewReplyComponent extends AngularNodeViewComponent {
  protected readonly MsgType = MsgType;
  protected readonly DateUtils = DateUtils;
  protected readonly testIds = SbMessageTestIds;
  private readonly accountService = inject(AccountService);
  private readonly FILE_ICON_MAP: Record<string, string> = {
    doc: 'word',
    docx: 'word',
    txt: 'file',
    mp4: 'play',
    pdf: 'file-pdf',
    image: 'image',
    png: 'image',
    jpeg: 'image',
    jpg: 'image',
    gif: 'image'
  };

  get sender(): string {
    return this.node().attrs['sender'] || '';
  }

  get body(): string {
    return this.node().attrs['body'] || '';
  }

  get formattedBody(): string | undefined {
    return this.node().attrs['formattedBody'];
  }

  get date(): Date | null {
    return this.node().attrs['date'] ? new Date(this.node().attrs['date']) : null;
  }

  get senderId(): string {
    return this.node().attrs['senderId'] || '';
  }

  get msgtype(): string {
    return this.node().attrs['msgtype'] || MsgType.Text;
  }

  get currentUserId(): string {
    return this.accountService.getMyMxId();
  }

  get fileName(): string {
    return this.node().attrs['fileName'] || this.body;
  }

  get fileSize(): number {
    return this.node().attrs['fileSize'] || 0;
  }

  formatFileSize(sizeInBytes: number): string {
    if (sizeInBytes === 0) return '0B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    return `${(sizeInBytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
  }

  getFileTypeIcon(fileName?: string): string | null {
    if (!fileName) return null;
    const extension = fileName.split('.').pop()?.toLowerCase();
    return this.FILE_ICON_MAP[extension!] || 'file';
  }

  onClose(): void {
    const pos = this.getPos()();
    if (pos !== undefined) {
      this.editor().commands.deleteRange({
        from: pos,
        to: pos + this.node().nodeSize
      });
    }
  }

  handleMention(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
